<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>

<div class="header-container mt-3" tabindex="0" id="leads-table">
  <h2 class="ml-2">Leads</h2> 
</div>
<div class="row assigned-lead mb-3">
  <div class="col mr-3">
    <div class="leads-table ml-1 mb-3">
      <table mat-table [dataSource]="dataSource" matSort class="mat-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef >Date</th>
          <td mat-cell *matCellDef="let element">{{ element?.current_stage?.action_date ?
            (element?.current_stage?.action_date | date: 'dd-MM-yyyy') : '-' }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="first_name">
          <th mat-header-cell *matHeaderCellDef >Name</th>
          <td mat-cell *matCellDef="let element">{{element.first_name}}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef >Email</th>
          <td mat-cell *matCellDef="let element" style="text-transform: lowercase;">{{element.email ? element.email :
            '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef >Phone Number</th>
          <td mat-cell *matCellDef="let element">{{element.mobile ? element.mobile :'-'}}</td>
        </ng-container>

        <ng-container matColumnDef="current_stage.stage">
          <th mat-header-cell *matHeaderCellDef >Lead Stage</th>
          <td mat-cell *matCellDef="let element">{{element.current_stage.stage ? element.current_stage.stage :'-'}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef >Status</th>
          <td mat-cell *matCellDef="let element" [ngClass]="element?.lead_status == 're-engaged' ? 're-engaged' : ''">
            {{element?.lead_status ? element?.lead_status : '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <a class="action-link"  *ngIf="element?.current_stage?.role_id != 3"
              (click)="slidingPanel.togglePanel(element)">Details</a>
              <a class="action-link"  *ngIf="element?.current_stage?.role_id == 3 "
              (click)="assignedSlidingPanel.togglePanel(element)">Details</a>  
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="6">No data found!</td>
        </tr>
      </table>

      <mat-paginator (page)="pageHandler($event)" [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>

    <app-details-panel #slidingPanel></app-details-panel>
    <app-assigned-details-panel #assignedSlidingPanel></app-assigned-details-panel>

  </div>
</div>